export default __webpack_public_path__ + "static/media/2.dad9439c.jpg";